import { TrackingConstant } from 'client/tracking/constant';
import { signInAnonymously } from 'site-modules/shared/components/profile/firebase-anonymous-auth';
import { getSyncDate } from 'site-modules/shared/components/profile/idm/idm-utils';
import { formatMergedAttributes } from 'site-modules/shared/components/profile/attributes/merged-attributes';
import { formatVehicleAttributes } from 'site-modules/shared/components/profile/attributes/vehicles';
import { SUBMIT_CTA } from 'site-modules/shared/constants/write-review/write-review';

function buildReviewPayload(reviewInfo, vehicleData, isNewUser, isAnonymousUser) {
  const { reviewId, email, authorName, styleId, year, make, model } = reviewInfo;
  const { modelLinkCode, type } = vehicleData;
  const dateNow = getSyncDate();
  const vehicle = {
    vin: reviewId,
    vehicleInfo: { styleInfo: { make, model, year: parseInt(year, 10), styleId } },
    type,
    modelLinkCode,
  };

  const payload = {
    pii: {
      contactInfo: {
        [reviewId]: {
          email,
        },
      },
    },
    edmundsMembership: {
      userName: authorName,
      updatedTs: dateNow,
      publishedReviews: [
        {
          reviewId,
          vinReference: `#/vehicles/vins/${reviewId}`,
          contactInfoReference: `#/pii/contactInfo/${reviewId}`,
        },
      ],
    },
    ...formatVehicleAttributes({ inventory: vehicle }, { nonVin: true }),
    ...formatMergedAttributes(vehicle),
  };

  if (isNewUser) {
    payload.edmundsMembership.firstContributionTs = dateNow;
  }

  if (isAnonymousUser || isNewUser) {
    payload.identifiers = { email: [email] };
  }

  return payload;
}

export async function saveReviewInfoToIdm({
  reviewInfo,
  vehicleData,
  isAuthenticated,
  isAnonymousUser,
  createAnonymousIdmProfile,
  updateIdmData,
}) {
  const reviewPayload = buildReviewPayload(reviewInfo, vehicleData, !isAuthenticated, isAnonymousUser);

  if (!isAuthenticated) {
    await signInAnonymously(null, {
      subaction_name: TrackingConstant.SUCCESS_EMAIL_ONLY_SIGN_UP,
      value: SUBMIT_CTA,
    });

    return createAnonymousIdmProfile(reviewPayload);
  }

  return updateIdmData(reviewPayload);
}
